import { GrowTypography } from "@sinecycle/growcomponents";
import {
  TypographyLinkProps,
  TypographyParagraphProps,
  TypographyTextProps,
  TypographyTitleProps,
} from "./type";

function AntTypographyText(props: TypographyTextProps) {
  return <GrowTypography.Text {...props} />;
}
function AntTypographyLink(props: TypographyLinkProps) {
  return <GrowTypography.Link {...props} />;
}
function AntTypographyTitle(props: TypographyTitleProps) {
  return <GrowTypography.Title {...props} />;
}
function AntTypographyParagraph(props: TypographyParagraphProps) {
  return <GrowTypography.Paragraph {...props} />;
}
export {
  AntTypographyLink as Link,
  AntTypographyParagraph as Paragraph,
  AntTypographyTitle as Title,
  AntTypographyText as TypographyText,
};
